export const LEGAL_DATA_MAX_HEIGHT_PX = 270;
export const DUPLICATE_WARNING_MAX_HEIGHT_PX = 56;
export const LEGAL_DATA_FOCUS_SHADOW_PX = 10;
export const LEGAL_DATA_NAME_MIN_HEIGHT_PX = 32;
